/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { HttpClient, HttpHandler } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

declare type Config = {
  baseApiUrl: string;
  message: string;
};

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly sessionKey: string = 'GFS_UI_CONFIG';
  private config: Config = {} as any;

  public get baseApiUrl(): string {
    return this.config?.baseApiUrl;
  }

  public get message(): string {
    return this.config?.message;
  }

  constructor() {
    this.config = JSON.parse(sessionStorage.getItem(this.sessionKey));
  }

  initialize(handler: HttpHandler): Promise<void> {
    if (this.config !== null) {
      return Promise.resolve();
    } else {
      return new HttpClient(handler).get<Config>('/config')
      .toPromise()
      .then(
        (config: Config) => {
          this.config = config;
        },
        () => {
          console.warn('Warning: falling back to local environments file.');
          this.config = {
            baseApiUrl: environment.baseApiUrl,
            message: environment.message
          };
        }
      ).then(
        () => {
          sessionStorage.setItem(this.sessionKey, JSON.stringify(this.config));
        }
      );
    }
  }
}
